var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('button',{class:{'customClass' : !_vm.customPosition},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('i',{staticClass:"fal fa-plus"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }